import { baseQueryParams } from 'src/utils';
import { getKeyByValue } from './getKeyByValue';

export const amountOfActiveFilters = (
  filters: Record<keyof typeof baseQueryParams, '' | string>,
  relevantFilters: string[]
): number | undefined => {
  if (!filters) return undefined;

  const activeFilters = relevantFilters.filter((filter) => {
    const paramKey = getKeyByValue(baseQueryParams, filter);
    if (paramKey) {
      return filters[paramKey as keyof typeof baseQueryParams];
    }
  });
  return activeFilters.filter(Boolean).length;
};
